import React, { useState, useEffect } from 'react';
import { Link } from 'react-scroll';
import { HiMenu, HiX } from 'react-icons/hi';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('hero');

  const toggleMenu = () => setIsOpen(!isOpen);

  const navItems = [
    { name: 'Home', to: 'hero' },
    { name: 'About', to: 'about' },
    { name: 'Services', to: 'services' },
    { name: 'Industries', to: 'industries' },
    { name: 'Projects', to: 'projects' },
    { name: 'Testimonials', to: 'testimonials' },
   // { name: 'Contact', to: 'contact' },
  ];

  // Scroll spy using middle of viewport
  useEffect(() => {
    const handleScroll = () => {
      const middleOfScreen = window.scrollY + window.innerHeight / 2;
      let current = 'hero';

      for (let item of navItems) {
        const section = document.getElementById(item.to);
        if (!section) continue;

        const sectionTop = section.offsetTop;
        const sectionBottom = sectionTop + section.offsetHeight;

        if (middleOfScreen >= sectionTop && middleOfScreen < sectionBottom) {
          current = item.to;
          break;
        }
      }

      setActiveSection(current);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <nav className="bg-blue-600 text-white fixed w-full z-50 shadow">
      <div className="container mx-auto flex justify-between items-center p-4">
        <h1 className="text-2xl font-bold cursor-pointer">Water Systems</h1>

        {/* Desktop Menu */}
        <ul className="hidden md:flex space-x-6">
          {navItems.map((item) => (
            <li key={item.to}>
              <Link
                to={item.to}
                smooth={true}
                duration={500}
                offset={-80}
                className={`cursor-pointer transition ${
                  activeSection === item.to
                    ? 'text-yellow-400 font-bold underline underline-offset-4'
                    : 'text-white hover:text-yellow-300'
                }`}
              >
                {item.name}
              </Link>
            </li>
          ))}
        </ul>

        {/* Mobile Menu Button */}
        <div className="md:hidden">
          <button onClick={toggleMenu}>
            {isOpen ? <HiX size={30} /> : <HiMenu size={30} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <ul className="md:hidden bg-blue-600 flex flex-col items-center space-y-4 pb-4">
          {navItems.map((item) => (
            <li key={item.to}>
              <Link
                to={item.to}
                smooth={true}
                duration={500}
                offset={-80}
                className={`cursor-pointer transition ${
                  activeSection === item.to
                    ? 'text-yellow-400 font-bold underline underline-offset-4'
                    : 'text-white hover:text-yellow-300'
                }`}
                onClick={toggleMenu} // close mobile menu on click
              >
                {item.name}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </nav>
  );
};

export default Navbar;
